module.exports = __webpack_public_path__ + "img/ups-cod-alternate.9556ae81.png";